import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ServicesService } from 'src/services/services.service';

export interface RegElement {
  required: any;
  name: String;
  show_in_card: any;
  hideshow: any;
  label: any;
  icard_label: any;
  type: any;
  value: any;
}


const ELEMENT_DATA: RegElement[] = [
  { name: 'payment_ss', required: false, hideshow: false, show_in_card: false, label: 'Payment Screenshot', icard_label: 'Payment Screenshot', type: '', value: '' },
  { name: 'image', required: false, hideshow: false, show_in_card: false, label: 'Image', icard_label: 'Image', type: '', value: '' },
  { name: 'id_proof', required: false, hideshow: false, show_in_card: false, label: 'ID Proof', icard_label: 'ID Proof', type: '', value: '' },
  { name: 'name', required: false, hideshow: false, show_in_card: false, label: 'Name', icard_label: 'Name', type: 'text', value: '' },
  { name: 'mobile', required: false, hideshow: false, show_in_card: false, label: 'Mobile No', icard_label: 'Mobile No', type: 'number', value: '' },
  { name: 'email', required: false, hideshow: false, show_in_card: false, label: 'Email', icard_label: 'Email', type: 'email', value: '' },
  { name: 'city', required: false, hideshow: false, show_in_card: false, label: 'City', icard_label: 'City', type: 'text', value: '' },
  { name: 'state', required: false, hideshow: false, show_in_card: false, label: 'State', icard_label: 'State', type: 'text', value: '' },
  { name: 'address', required: false, hideshow: false, show_in_card: false, label: 'Address', icard_label: 'Address', type: 'text', value: '' },
  { name: 'tic_category', required: false, hideshow: false, show_in_card: false, label: 'Ticket Category', icard_label: 'Ticket Category', type: 'radio', value: '' },
  { name: 'allowed_person', required: false, hideshow: false, show_in_card: false, label: 'Allowed Person', icard_label: 'Allowed Person', type: 'number', value: '' },
  { name: 'date', required: false, hideshow: false, show_in_card: false, label: 'Date', icard_label: 'Date', type: 'date', value: { start: null, end: null } },
  { name: 'field1', required: false, hideshow: false, show_in_card: false, label: 'Field 1', icard_label: 'Field 1', type: '', value: '' },
  { name: 'field2', required: false, hideshow: false, show_in_card: false, label: 'Field 2', icard_label: 'Field 2', type: '', value: '' },
  { name: 'field3', required: false, hideshow: false, show_in_card: false, label: 'Field 3', icard_label: 'Field 3', type: '', value: '' },
  { name: 'field4', required: false, hideshow: false, show_in_card: false, label: 'Field 4', icard_label: 'Field 4', type: '', value: '' },
  { name: 'field5', required: false, hideshow: false, show_in_card: false, label: 'Field 5', icard_label: 'Field 5', type: '', value: '' },
  { name: 'field6', required: false, hideshow: false, show_in_card: false, label: 'Field 6', icard_label: 'Field 6', type: '', value: '' },
  { name: 'field7', required: false, hideshow: false, show_in_card: false, label: 'Field 7', icard_label: 'Field 7', type: '', value: '' },
  { name: 'field8', required: false, hideshow: false, show_in_card: false, label: 'Field 8', icard_label: 'Field 8', type: '', value: '' },
  { name: 'field9', required: false, hideshow: false, show_in_card: false, label: 'Field 9', icard_label: 'Field 9', type: '', value: '' }
];

@Component({
  selector: 'app-app-registration-setting',
  templateUrl: './app-registration-setting.component.html',
  styleUrls: ['./app-registration-setting.component.scss'],
  standalone: false
})
export class AppRegistrationSettingComponent {
  displayedColumns: string[] = [
    'name',
    'hideshow',
    'required',
    'show_in_card',
    'label',
    'icard_label',
    'type',
    'value'
  ];
  dataSource = ELEMENT_DATA;
  mainmemberFinalArr: RegElement[] = [];
  directory_id: any;
  reg_setting_data: any;
  event_id: any;
  user_id: any;

  constructor(
    private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.event_id = params['event_id'];
      this.user_id = params['user_id'];
      this.Get_Reg_Setting(this.event_id);
    });
  }

  isChangeLimitAccessToggle(event: any) {
    const checkboxValue = event.checked ? true : false;
    this.dataSource.forEach(element => element.required = checkboxValue);
  }

  isChangeLimitAccessToggleHide(event: any) {
    const checkboxValue = event.checked; // No need for `? true : false`, as `event.checked` is already a boolean

    this.dataSource.forEach(element => {
      element.hideshow = checkboxValue;

      if (!checkboxValue) {
        element.show_in_card = false; // Uncheck show_in_card when hideshow is disabled
      }
    });
  }

  hideshowChange(element: any) {

    if (!element.hideshow) {
      element.show_in_card = false;
      element.required = false;
    }
  }

  Get_Reg_Setting(event_id: any) {
    this.service.get_reg_setting(event_id).subscribe((data: any) => {
      if (data && Array.isArray(data.data)) {
        this.reg_setting_data = data.data;

        ELEMENT_DATA.forEach(element => {
          // Reset the hideshow, required, and label properties
          element.hideshow = false;
          element.show_in_card = false;
          element.required = false;
          // element.label = '';

          // Find the corresponding reg_setting_data
          const regSetting = this.reg_setting_data.find((setting: any) => setting.fields.toLowerCase() === element.name.toLowerCase());

          if (regSetting) {
            element.hideshow = regSetting.hide_show !== "0";
            element.show_in_card = regSetting.show_in_card !== "0";
            element.required = regSetting.require !== "0";
            element.label = regSetting.label;
            element.icard_label = regSetting.icard_label;
            element.type = regSetting.type;
            element.value = regSetting.value;
          }
        });
      }
    });
  }

  onShowcardChange(event: any) {
    const checked = event.checked;
    const selectedCount = this.dataSource.filter(el => el.show_in_card).length;
    console.log(selectedCount);


    if (checked && selectedCount > 5) {
      // Uncheck the checkbox and display an error message
      event.source.checked = false;
      this.toastr.warning('You cannot select more than 5 Fields For ID-Card.');
    }
  }

  Submit() {
    const requiredElements = this.dataSource.filter(element => element.required);
    const hideShowElements = this.dataSource.filter(element => element.hideshow);
    const Cardlements = this.dataSource.filter(element => element.show_in_card);

    const allElements = [...requiredElements, ...hideShowElements, ...Cardlements];

    const uniqueElements = Array.from(new Set(allElements.map(e => e.name)))
      .map(name => allElements.find(e => e.name === name))
      .filter((e): e is RegElement => e !== undefined); // Filter out undefined values

    // Sort the elements based on the order defined in ELEMENT_DATA
    const order = ELEMENT_DATA.map(e => e.name);
    this.mainmemberFinalArr = uniqueElements.sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name));

    console.log(this.mainmemberFinalArr);
    this.service.app_edit_reg_setting(this.mainmemberFinalArr, this.event_id, this.user_id).subscribe(
      (data: any) => {
        this.toastr.success('Setting Updated Succesfully');
      }
    );
  }

}